import { getBrowser } from 'utils/getBrowser';
import { v4 } from 'uuid';
import { observable, action, makeObservable } from 'mobx';
import { ISalesForceDataManager } from 'typings/dataManagers';
import { dataManagerFactory } from 'utils/MobxDataManager/singletons';
import * as searchTermsUtils from 'utils/searchTermUtils';

export class ContactFormHelper {
    @observable isOpen: boolean;
    @observable currentPage: string;
    @observable salesForceArticles: ArticleSuggestion[];
    @observable isFullPageHelpForm: boolean;
    @observable salesForceSearchTerms: string;
    private _salesForceDataManager: ISalesForceDataManager;

    constructor() {
        makeObservable(this);
        this._salesForceDataManager = dataManagerFactory.getSalesForceDataManager();
        this.salesForceArticles = [];
        this.isFullPageHelpForm = false;
        this.salesForceSearchTerms = '';
    }

    @action
    toggleSlideout(): void {
        this.isOpen = !this.isOpen;
    }

    @action
    setFullPageHelpForm(): void {
        this.isFullPageHelpForm = true;
    }

    setCurrentPage(page: string): void {
        this.currentPage = page;
    }

    @action
    setSearchTerms(path: string, search: string): void {
        this.salesForceSearchTerms = searchTermsUtils.getPageUrlSearchTerms(path, search);
    }

    @action
    async getSuggestedArticles(searchTerms: string, limitArticles: boolean = false): Promise<void> {
        const result = await this._salesForceDataManager.getSuggestedArticles(searchTerms);
        if (limitArticles) {
            this.salesForceArticles = result.slice(0, 3);
            return;
        }
        this.salesForceArticles = result;
    }

    @action
    async getArticleById(id: string): Promise<void> {
        this.salesForceArticles = await this._salesForceDataManager.getArticleById(id);
    }


    goToArticle(id: string) {
        const route = `${window.location.origin}/help?id=${id}`;
        window.open(route);
    }

    async submitForm(formData: ContactFormData):Promise<TicketSubmissionResult> {
        //  NOTE: IE11 and Edge do NOT support the File Constructor which would be cleaner
        //  Since that's the case, we need to send a blob of data instead of a File object
        const uploadFiles: Blob[] = [];

        if (!formData.attachments) {
            formData.attachments = [];
        }

        formData.attachments.forEach(attachment => {
            const blob = new Blob([attachment], { type: attachment.type });
            //  this is required or the blob won't be considered a file when form is submitted
            blob.lastModifiedDate = new Date();
            uploadFiles.push(blob);
        });

        uploadFiles.forEach(f => (f.uuid = v4));

        try {
            const multiPartForm = new FormData();
            multiPartForm.append('summary', formData.subject ?? '');
            multiPartForm.append('description', formData.description ?? '');
            multiPartForm.append('priority', formData.priority ?? '');
            multiPartForm.append('ticket_type', 'Bug Report');

            for (let i = 0; i < uploadFiles.length; i++) {
                multiPartForm.append('theFile', uploadFiles[i], formData.attachments[i].name);
            }

            multiPartForm.append('system', formData.productName ?? '');
            multiPartForm.append('browser', getBrowser());
            multiPartForm.append('mp_url', formData.sourceUrl ?? '');

            return await this._salesForceDataManager.createTicket(multiPartForm);

        } catch (err) {
            return {
                success: false,
                ticketId: 0
            } as TicketSubmissionResult;
        }
    }
}